// extracted by mini-css-extract-plugin
module.exports = {"header":"_3JR5a1","container":"_2Sb0fh","icon":"_3UI_BD","text":"_29-_Pg","fakeHeader":"_1IxVPr"};